module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Chief abbreviations")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "Tab1"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "7",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "18%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("AB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Anchor Bible")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ABD")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("D. N. Freedman et al. (eds.), "), _c('i', [_vm._v("The Anchor Bible Dictionary")]), _vm._v(", 6 vols. (Garden City, New York: Doubleday, 1992)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AD")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Anno Domini")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("anc.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ancient")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ANE")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Ancient Near East")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ANEP")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("J. B. Pritchard, "), _c('i', [_vm._v("The Ancient Near East in Pictures")]), _vm._v(", 2nd edn with suppl. (Princeton: Princeton University Press, 1969)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ANET")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("J. B. Pritchard, (ed.), "), _c('i', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(", 3rd edn with suppl. (Princeton: Princeton University Press, 1969)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("AOTC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Abingdon Old Testament Commentaries")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Aram.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Aramaic")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("b")]), _vm._v(". ("), _c('i', [_vm._v("Talm")]), _vm._v(".)")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Babylonian ("), _c('i', [_vm._v("Talmud)")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("BBCOT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("J. H. Walton et al. (eds.), "), _c('i', [_vm._v("IVP Bible Background Commentary: Old Testament ")]), _vm._v("(Downers Grove, Ill.: InterVarsity Press, 2000)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BC")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Before Christ")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("BHQ")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("A. Gelston, "), _c('i', [_vm._v("Biblia Hebraica Quinta 13")]), _vm._v(": "), _c('i', [_vm._v("The Twelve Minor Prophets ")]), _vm._v("(Stuttgart: Deutsche Bibelgesellschaft, 2010)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("BHS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("K. Elliger and W. Rudolf (eds.), "), _c('i', [_vm._v("Biblia Hebraica Stuttgartensia ")]), _vm._v("(Stuttgart: Deutsche Bibelgesellschaft, 1984)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("BibSem")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Biblical Seminar")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("BZAW")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Beiheft zur ZAW")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CAT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Commentaire de l‘Ancien Testament")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CBC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Cambridge Bible Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("CBQ")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Catholic Biblical Quarterly")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ch.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("chapter(s)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CorBC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Cornerstone Biblical Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("CTR")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Criswell Theological Review")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("CurTM")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Currents in Theology and Mission")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("DOTPen")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("T. D. Alexander and D. W. Baker (eds.), "), _c('i', [_vm._v("Dictionary of the Old Testament Pentateuch ")]), _vm._v("(Downers Grove, Ill.: InterVarsity Press, 2003)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("DSBOT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Daily Study Bible (Old Testament)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("EB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("English Bible")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("EBC")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Expositor’s Bible Commentary ")]), _vm._v("(Revised)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ed(s).")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("editor(s)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("edn")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("edition")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("EncJud")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Encyclopaedia Judaica")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Eng.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("English")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("esp.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("especially")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("EvBC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Everyman’s Bible Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EVV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("English versions")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Fig.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Figure")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("FOTL")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Forms of Old Testament Literature")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("FRLANT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Forschungen zur Religion und Literatur des Alten und Neuen Testaments")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Gk")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Greek")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("GKC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("E. Kautzsch (ed.), "), _c('i', [_vm._v("Gesenius’ Hebrew Grammar ")]), _vm._v("(Oxford: Clarendon Press, 1910).")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Hag-Zech-Mal corpus")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("The books of Haggai, Zechariah and Malachi understood as a related literary collection")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("HAR")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Hebrew Annual Review")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("HB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Hebrew Bible")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Heb.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Hebrew")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("HolOTC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Holman Old Testament Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("HSM")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Harvard Semitic Monographs")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("IBHS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("B. K. Waltke and M. O’Connor, "), _c('i', [_vm._v("An Introduction to Biblical Hebrew Syntax ")]), _vm._v("(Winona Lake, IN.: "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Eisenbrauns, 1990)")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ICC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("International Critical Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Int")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Interpretation")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Int")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Interpretation Commentary Series")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ITC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("International Theological Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("JAOS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Journal of the American Oriental Society")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("JETS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("JPSV")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Jewish Publication Society of America Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("JSOT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Journal for the Study of the Old Testament")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("JSOTSup")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Journal for the Study of the Old Testament Supplementary series")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("KAT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Kommentar zum Alten Testament")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Lat.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Latin")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("lit.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("literally")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LXX")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Septuagint (pre-Christian Greek version of the Old Testament)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LXX ")]), _vm._v("A")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Codex Alexandrinus")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LXX ")]), _vm._v("B")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Codex Vaticanus")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LXX ")]), _vm._v("Q")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Codex Marchallianus")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Massoretic Text (the standard Hebrew text of the Old Testament)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Mur")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Wadi Murabba’at")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("n.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("note")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NAC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New American Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NCBC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Century Bible Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("NDBT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("T. D. Alexander, B. S. Rosner, D. A. Carson, G. Goldsworthy (eds.), "), _c('i', [_vm._v("New Dictionary of Biblical Theology ")]), _vm._v("(Leicester: Inter-Varsity Press, 2000)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NETS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("A. Pietersman and B. C. Wright, (eds.), "), _c('i', [_vm._v("A New English Translation of the Septuagint ")]), _vm._v("(New York: Oxford University Press, 2007)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("NIB")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("L. E. Keck (ed.), "), _c('i', [_vm._v("The New Interpreter’s Bible ")]), _vm._v("(Nashville: Abingdon Press, 1994–), 12 vols.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NICOT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New International Commentary on the Old Testament")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("NIDB")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("New Interpreter’s Dictionary of the Bible")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("NIDOTTE")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("W. A. VanGemeren (gen. ed.), "), _c('i', [_vm._v("New International Dictionary of Old Testament Theology and Exegesis")]), _vm._v(" "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("(Grand Rapids: Zondervan, 1997), 5 vols.")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NIrV")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New International Reader’s Version, 1994")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NIVAC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NIV ")]), _vm._v("Application Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NJPS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Jewish Publication Society, 1985")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NSBT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Studies in Biblical Theology")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Testament")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("OT")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Old Testament")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("OTL")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Old Testament Library")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("para.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("paragraph")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("pl")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("plural")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Q")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Qumran")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("repr.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("reprint")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("RevExp")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Review and Expositor")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SBLDS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("SBLMS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Society of Biblical Literature Monograph Series")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("sing.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("singular")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ST")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Studia Theologica")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("suppl.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("supplement")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Symp")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Symposium")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Syr.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Syriac")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Targ.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Targum")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("TBT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("The Bible Today")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("TDOT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("G. J. Botterweck and H. Ringgren (eds.), "), _c('i', [_vm._v("Theological Dictionary of the Old Testament ")]), _vm._v("(Grand Rapids: Eerdmans, 1974–)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("TOTC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Tyndale Old Testament Commentaries")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("trans.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("translator")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("TynB")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Tyndale Bulletin")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("UBS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("United Bible Societies")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("v./vv.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("verse/verses")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("vers.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("version(s)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("vol(s).")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("volume(s)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("VT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Vetus Testamentum")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("VTSup")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Vetus Testamentum Supplement")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Vulg.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Vulgate")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("WBC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Word Biblical Commentary")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ZAW")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Zeitschrift für die Alttestamentliche Wissenschaft")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ZIBBCOT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p19"
    }
  }, [_vm._v("J. H. Walton (gen. ed.), "), _c('i', [_vm._v("Zondervan Illustrated Bible ")])]), _c('i', [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Backgrounds Commentary")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("(Grand Rapids: Zondervan, 2009), 5 vols.")])])])])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Bible Versions")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "7",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "18%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CEV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Contemporary English Version, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("opyright © 1995 American Bible Society")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ESV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("English Standard Version, published by HarperCollins Publishers © 2001 by Crossway Bibles, a division of Good News Publishers")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("HCSB")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Holman Christian Standard Bible, © copyright 1999 [2004] by Holman Bible Publishers")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("KJV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("King James Version")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NAB")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New American Bible, copyright © 1995 by Oxford University Press, Inc. New York")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NEB")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New English Bible, copyright © Oxford University Press and Cambridge University Press 1961, 1970")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NIV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New International Version, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("opyright © 1973, 1978, 1984")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NIV ")]), _vm._v("2011")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New International Version 2011, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("opyright © 1973, 1978. 1984, 2011 by Biblica, Inc.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NJB")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Jerusalem Bible, copyright © 1985 by Darton, Longman & Todd Ltd and Doubleday, a division of Bantam Doubleday Dell Publishing Group, Inc.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NKJV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New King James Version, copyright © 1982 by Thomas Nelson, Inc.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NLT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Living Translation, copyright © 1996 [2004, 2007]. Anglicized version, copyright © 2000.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NRSV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New Revised Standard Version, Anglicized edition, copyright © 1989, 1995 by the Division of Christian Education of the National Council of the Churches of Christ in the USA")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Revised English Version, 1881")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TEV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Today’s English Version (Good News Translation), copyright © 1992 American Bible Society")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TNIV")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Today’s New International Version, copyright © 2001 [2005] by International Bible Society")])])])])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 75
// module chunks = 0